// useGetEmployees.js
import { useEffect, useState } from 'react';
import { APP_SERVICES_URL } from '../Constant/constant';
import userSession from '../Constant/auth';

const useGetEmployees = () => {
  const [employees, setEmployees] = useState([]);
  // eslint-disable-next-line
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line
  const [error, setError] = useState(null);
  const { CustID, authHeader,site } = userSession;
  useEffect(() => {
    const fetchEmployees = async () => {

      try {
        const response = await fetch(`${APP_SERVICES_URL}/senapi/${CustID}/employees?siteNames=${site.name}`, {
          method: 'GET',
          headers: {
            Authorization: authHeader,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch employees data');
        }

        const employeeData = await response.json();
        setEmployees(employeeData);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };

    fetchEmployees();
  }, [CustID, site,authHeader]);

  return { employees };
};

export default useGetEmployees;
